import i18nConfig from '@/i18nConfig'

export const createSlug = (id: string | number, title: string) => {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .trim() // Trim whitespace
    .replace(/\s+/g, '-') // Replace spaces with hyphens
  return `${id.toString()}-${slug}`
}

export const extractIdFromSlug = (slug: string) => {
  // Split the slug by hyphen
  const idPart = slug.split('-')[0]

  // Check if the extracted part is a valid number
  const id = parseInt(idPart, 10)
  if (isNaN(id)) {
    return null // or handle the error as needed
  }

  return id
}

export const buildLocalePath = (locale: string, path: string) => {
  if (!path.startsWith('/') || path.startsWith('//')) {
    return path
  }

  // The default locale is served unprefixed (`prefixDefault: false`), so
  // prefixing it (`/en/...`) only forces a 307 redirect back to the clean URL.
  if (locale === i18nConfig.defaultLocale && !i18nConfig.prefixDefault) {
    return path
  }

  return path === '/' ? `/${locale}` : `/${locale}${path}`
}

/**
 * Locale-prefix an href that came from content (a CMS hero CTA, a static
 * link). Unlike `buildLocalePath` it accepts hrefs that may ALREADY carry a
 * locale (`/ar/register`) and leaves those alone, so an editor who typed the
 * prefix does not get `/ar/ar/register`. External URLs, protocol-relative
 * URLs and hash/query-only hrefs pass through untouched.
 *
 * Why it matters: an unprefixed `/register` is resolved by the i18n router
 * from the NEXT_LOCALE cookie or the browser language, so a first-time visitor
 * on /ar with an English browser is sent to the English page.
 */
export const localizeHref = (locale: string, href: string) => {
  if (!href.startsWith('/') || href.startsWith('//')) return href

  const firstSegment = href.split(/[/?#]/)[1]
  if (firstSegment && i18nConfig.locales.includes(firstSegment)) return href

  return buildLocalePath(locale, href)
}
